<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">
    <ng-container *ngIf="!newBroadcast && hasBeenSent"> View Broadcast </ng-container>
    <ng-container *ngIf="!newBroadcast && !hasBeenSent"> Edit Broadcast </ng-container>
    <ng-container *ngIf="newBroadcast"> Create Broadcast </ng-container>
  </div>
  <div class="header-right">
    <button
      *ngIf="newBroadcast"
      mat-button
      color="lightGreen"
      (click)="saveNewBroadcast()"
      [disabled]="saveDisabled"
    >
      Save New Broadcast
    </button>
    <button
      *ngIf="!newBroadcast && !hasBeenSent"
      mat-button
      color="lightGreen"
      (click)="saveBroadcastUpdate()"
      [disabled]="saveDisabled"
    >
      Save Broadcast
    </button>
  </div>
</div>

<div class="broadcast">
  <div class="audience-container-group">
    <div class="container broadcast-container">
      <div class="container-content">
        <div class="container-row">
          <lhpe-select
            controlName="audience"
            placeholder="Select audience"
            [formGroup]="broadcastFormGroup!"
            [required]="true"
            [options]="audiences"
            [optionIsSelf]="true"
            displayValue="name"
          >
          </lhpe-select>

          <!--
          <button
            *ngIf="!hasBeenSent"
            mat-button
            color="fiord"
            (click)="onViewAudiences()"
          >
            View audiences
          </button>
        -->

          <button
            *ngIf="!hasBeenSent"
            mat-button
            color="lightGreen"
            (click)="onCreateNewAudience()"
          >
            Create new
          </button>
        </div>
        <ng-container *ngIf="audienceSelected">
          <div class="container-row audience-size-row">
            Audience size: <span class="number">{{ audienceCount }}</span>
          </div>
          <div class="container-row">
            <lhpe-select
              controlName="broadcastChannel"
              placeholder="Select broadcast channel"
              [formGroup]="broadcastFormGroup!"
              [required]="true"
              [options]="broadcastChannelOptions"
            >
            </lhpe-select>
          </div>

          <ng-container *ngIf="broadCastChannelSelected && mobilePushSelected">
            <div class="container-row">
              <lhpe-input
                class="input"
                controlName="broadcastName"
                placeholder="Broadcast name"
                [formGroup]="mobilePushFormGroup!"
                [required]="true"
              >
              </lhpe-input>
            </div>
            <div class="container-row or-row">
              <lhpe-select
                controlName="template"
                placeholder="Select template"
                [formGroup]="mobilePushFormGroup!"
                [required]="true"
                [options]="templateOptions"
                [optionIsSelf]="true"
                displayValue="name"
              >
              </lhpe-select>
              <ng-container *ngIf="!hasBeenSent && hasTemplatesWrite">
                <div class="or">or</div>

                <button
                  mat-button
                  color="lightGreen"
                  (click)="goToNewTemplate()"
                >
                  New
                </button>
              </ng-container>
            </div>
            <div class="container-row">
              <lhpe-select
                controlName="category"
                placeholder="Tracking category"
                [formGroup]="mobilePushFormGroup!"
                [required]="true"
                [options]="trackingCategoryOptions"
                [optionIsSelf]="true"
                displayValue="name"
              >
              </lhpe-select>
            </div>

            <div class="payload" *ngIf="hasPayloadForm">
              <div
                *ngIf="!hasBeenSent || hasCompletedProperty"
                class="container-row"
              >
                <div class="row-label">Payload</div>
              </div>
              <ng-container *ngFor="let property of payloadProperties">
                <div
                  *ngIf="!hasBeenSent || property.completed"
                  class="container-row"
                >
                  <lhpe-input
                    class="property-key"
                    [control]="property.keyControl"
                    placeholder="Enter Key Name"
                  >
                  </lhpe-input>

                  <lhpe-input
                    class="property-value"
                    [control]="property.valueControl"
                    [placeholder]="property.keyNamePrefix + ' Key Value'"
                    [matAutocomplete]="value"
                  >
                  </lhpe-input>

                  <mat-autocomplete #value="matAutocomplete">
                    <mat-option
                      *ngFor="let option of property.valueAutoCompleteOptions"
                      [value]="option.value"
                      (click)="addPayloadProperty(property)"
                    >
                      [{{ option.value }}] {{ option.label }}
                    </mat-option>
                  </mat-autocomplete>

                  <button
                    *ngIf="property.completed && !hasBeenSent"
                    mat-button
                    color="warn"
                    (click)="removePayloadProperty(property)"
                  >
                    <svg-icon
                      src="assets/svg/trashcan.svg"
                      [svgStyle]="{
                        'width.px': '22.5',
                        'height.px': '22.298'
                      }"
                      svgClass="white"
                    ></svg-icon>
                  </button>

                  <button
                    *ngIf="!property.completed && !property.keyNameIsLookup"
                    mat-button
                    color="lightGreen"
                    [disabled]="
                      property.keyControl.invalid ||
                      property.valueControl.invalid
                    "
                    (click)="addPayloadProperty(property)"
                  >
                    ADD
                  </button>
                </div>
              </ng-container>
            </div>

            <div *ngIf="hasOffer" class="container-row">
              <lhpe-select
                [control]="offerControl"
                placeholder="Offer"
                [options]="offers"
                [optionIsSelf]="true"
                displayValue="name"
              >
              </lhpe-select>
            </div>

            <ng-container *ngIf="hasOffer && offerControl?.value?.id !== null">
              <ng-container *ngFor="let field of offerFields">
                <div *ngIf="!field.hidden" class="container-row">
                  <lhpe-select
                    *ngIf="field.type === 'Select'"
                    [placeholder]="field.label"
                    [control]="field.control"
                    [options]="field.options"
                    displayValue="label"
                    [optionIsSelf]="true"
                    [required]="field.required"
                    [matTooltip]="field.hint"
                    matTooltipPosition="below"
                  >
                  </lhpe-select>

                  <lhpe-input
                    *ngIf="field.type === 'String'"
                    [placeholder]="field.label"
                    [control]="field.control"
                    [required]="field.required"
                    [matTooltip]="field.hint"
                    matTooltipPosition="below"
                  >
                  </lhpe-input>

                  <lhpe-input
                    *ngIf="field.type === 'Integer'"
                    [placeholder]="field.label"
                    [control]="field.control"
                    [required]="field.required"
                    [matTooltip]="field.hint"
                    matTooltipPosition="below"
                    type="number"
                  >
                  </lhpe-input>

                  <div
                    *ngIf="field.type === 'Date'"
                    class="date"
                    [matTooltip]="field.hint"
                    matTooltipPosition="below"
                  >
                    <div class="column">
                      <div class="row">
                        <lhpe-datepicker
                          #datePicker
                          [hideToggle]="true"
                          placeholder="mm/dd/yyyy"
                          [control]="field.control"
                          [required]="field.required"
                        >
                        </lhpe-datepicker>
                      </div>
                      <div class="row">
                        <div class="time-input-box">
                          <ngx-mat-timepicker-field
                            [disabled]="hasBeenSent"
                            color="primary"
                            [defaultTime]="field.timeString"
                            (timeChanged)="
                              onTimePickerTimeChanged($event, field)
                            "
                          ></ngx-mat-timepicker-field>
                        </div>
                      </div>
                    </div>
                    <div
                      style="height: 100%; display: flex; align-items: center"
                    >
                      <button
                        [disabled]="hasBeenSent"
                        mat-button
                        class="icon-btn"
                        (click)="datePicker.openPicker()"
                      >
                        <svg-icon
                          src="assets/svg/calendar.svg"
                          [svgStyle]="{
                            'width.px': '26.5',
                            'height.px': '26.5'
                          }"
                          svgClass="grey"
                        >
                        </svg-icon>
                      </button>
                    </div>

                    <div class="text">{{ field.label }}</div>
                  </div>

                  <div *ngIf="field.type === 'Interval'" class="interval">
                    <lhpe-input
                      [placeholder]="field.label"
                      [control]="field.control"
                      [required]="field.required"
                      [matTooltip]="field.hint"
                      matTooltipPosition="below"
                      type="number"
                    >
                    </lhpe-input>
                    <lhpe-select
                      placeholder="Interval"
                      [control]="field.intervalControl"
                      [options]="intervalOptions"
                      [optionIsSelf]="true"
                      [required]="field.required"
                    >
                    </lhpe-select>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <!-- CONTENT/ASSISTANT -->
            <div class="heading" *ngIf="contentAssistantIntegration !== undefined && !hasBeenSent">
              <div
                *ngFor="let tab of contentTabs"
                class="tab"
                (click)="contentTabChanged(tab)"
                [ngClass]="{
                  selected: currentContentTab === tab
                }"
              >
              <svg-icon
                *ngIf="tab.icon"
                class="icon"
                src="assets/svg/{{tab.icon!}}.svg"
                [svgStyle]="{
                  'width.px': '18',
                  'height.px': '18'
                }"
              ></svg-icon>
                {{ tab.name }}
              </div>
            </div>

            <div *ngIf="currentContentTab?.code === 'content'" class="tabContent">

              <div class="container-row">
                <lhpe-input
                  class="input"
                  controlName="notificationHeadline"
                  placeholder="Push notification and content headline"
                  [formGroup]="mobilePushFormGroup!"
                  [required]="true"
                >
                </lhpe-input>
              </div>
              <div class="container-row">
                <lhpe-textarea
                  class="input"
                  controlName="notificationText"
                  placeholder="Push notification text"
                  [formGroup]="mobilePushFormGroup!"
                  [rows]="3"
                  [required]="true"
                >
                </lhpe-textarea>
              </div>
              <div class="container-row editor">
                <editor apiKey="ck8ze3gv5uipup94hehaevo1z6p1h9eh4wzi0h86qad6xam6" [init]="{plugins: 'link', menubar: false, statusbar: false, height: '300px', width: '100%'}" [(ngModel)]="bodyContent" (ngModelChange)="bodyContentChanged($event)"></editor>
                
                <lhpe-textarea
                  class="hidden"
                  controlName="bodyContent"
                  placeholder="Body content"
                  [formGroup]="mobilePushFormGroup!"
                  [rows]="8"
                  [required]="true"
                >
                </lhpe-textarea>
              </div>

              <button
                mat-button
                class="preview-btn"
                color="fiord"
                (click)="preview('mobilePush')"
                [disabled]="
                  broadcastFormGroup.invalid || mobilePushFormGroup.invalid
                "
              >
                Preview
              </button>

            </div>

            <div *ngIf="currentContentTab?.code === 'assistant' && contentAssistantIntegration !== undefined" class="assistant">
              <app-assistant-chat [integration]="contentAssistantIntegration" [content]="contentAssistantData" [previewFn]="this.preview.bind(this)" [closeFn]="this.endAssistant.bind(this)"></app-assistant-chat>
            </div>

          </ng-container>

          <!-- EMAIL -->
          <ng-container
            *ngIf="
              broadCastChannelSelected &&
              this.broadcastFormGroup.controls.broadcastChannel.value ===
                'email'
            "
          >
            <div class="container-row">
              <lhpe-select
                controlName="email"
                placeholder="Email"
                [formGroup]="emailFormGroup!"
                [required]="true"
                [options]="emailOptions"
                optionValue="name"
              >
              </lhpe-select>
            </div>

            <div class="container-row">
              <lhpe-input
                class="input"
                controlName="broadcastName"
                placeholder="Broadcast name"
                [formGroup]="emailFormGroup!"
                [required]="true"
              >
              </lhpe-input>
            </div>

            <div class="container-row or-row">
              <lhpe-select
                controlName="template"
                placeholder="Select template"
                [formGroup]="emailFormGroup!"
                [required]="true"
                [options]="templateOptions"
                [optionIsSelf]="true"
                displayValue="name"
              >
              </lhpe-select>
              <div *ngIf="!hasBeenSent" class="or">or</div>

              <button *ngIf="!hasBeenSent" mat-button color="lightGreen">
                New
              </button>
            </div>

            <div class="container-row">
              <lhpe-select
                controlName="trackingCategory"
                placeholder="Tracking Category"
                [formGroup]="mobilePushFormGroup!"
                [required]="true"
                [options]="trackingCategoryOptions"
                [optionIsSelf]="true"
                displayValue="name"
              >
              </lhpe-select>

              <button mat-button color="fiord">Preview</button>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              broadCastChannelSelected &&
              this.broadcastFormGroup.controls.broadcastChannel.value === 'sms'
            "
          >
            <div class="container-row">
              <lhpe-input
                class="input"
                controlName="broadcastName"
                placeholder="Broadcast name"
                [formGroup]="smsFormGroup!"
                [required]="true"
              >
              </lhpe-input>
            </div>
            <div class="container-row">
              <lhpe-select
                controlName="trackingCategory"
                placeholder="Tracking Category"
                [formGroup]="smsFormGroup!"
                [required]="true"
                [options]="trackingCategoryOptions"
                [optionIsSelf]="true"
                displayValue="name"
              >
              </lhpe-select>
            </div>
            <div class="container-row">
              <lhpe-input
                class="input"
                controlName="textLabel"
                placeholder="Text label"
                [formGroup]="smsFormGroup!"
                [required]="true"
              >
              </lhpe-input>
            </div>
            <div class="container-row">
              <lhpe-textarea
                class="input"
                controlName="messageBody"
                placeholder="Message body"
                [formGroup]="smsFormGroup!"
                [required]="true"
              >
              </lhpe-textarea>
            </div>
            <div class="container-row">
              <lhpe-input
                class="input"
                controlName="link"
                placeholder="Link"
                [formGroup]="smsFormGroup!"
                [required]="true"
              >
              </lhpe-input>
              <button mat-button color="fiord">Preview</button>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              broadCastChannelSelected &&
              this.broadcastFormGroup.controls.broadcastChannel.value ===
                'browserPush'
            "
          >
            <div class="container-row">
              <lhpe-input
                controlName="broadcastName"
                placeholder="Broadcast name"
                [formGroup]="browserPushFormGroup!"
                [required]="true"
              >
              </lhpe-input>
            </div>
            <div class="container-row">
              <lhpe-select
                controlName="trackingCategory"
                placeholder="Tracking Category"
                [formGroup]="browserPushFormGroup!"
                [required]="true"
                [options]="trackingCategoryOptions"
                [optionIsSelf]="true"
                displayValue="name"
              >
              </lhpe-select>
            </div>
            <div class="container-row">
              <lhpe-input
                controlName="notificationHeadline"
                placeholder="Notification headline"
                [formGroup]="browserPushFormGroup!"
                [required]="true"
              >
              </lhpe-input>
            </div>
            <div class="container-row">
              <lhpe-textarea
                controlName="notificationBody"
                placeholder="Notification body"
                [formGroup]="browserPushFormGroup!"
                [required]="true"
              >
              </lhpe-textarea>
            </div>
            <div class="container-row">
              <lhpe-input
                controlName="actionLabel"
                placeholder="Action label"
                [formGroup]="browserPushFormGroup!"
                [required]="true"
              >
              </lhpe-input>
            </div>
            <div class="container-row">
              <lhpe-input
                controlName="actionLink"
                placeholder="Action link"
                [formGroup]="browserPushFormGroup!"
                [required]="true"
              >
              </lhpe-input>
              <button mat-button color="fiord">Preview</button>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="audienceSelected" class="tags-send-container-group">
    <div class="container send-container">
      <div class="inner-container">
        <div class="container-row">
          <div class="row-label">Send at</div>
        </div>
        <div class="container-row date-row send-date-row">
          <div class="icon">
            <button
              mat-button
              class="icon-btn"
              (click)="sendDatePicker.openPicker()"
              [disabled]="hasBeenSent"
            >
              <svg-icon
                src="assets/svg/calendar.svg"
                [svgStyle]="{
                  'width.px': '26.5',
                  'height.px': '26.5'
                }"
                svgClass="grey"
              >
              </svg-icon>
            </button>
          </div>
          <lhpe-datepicker
            class="date-picker"
            #sendDatePicker
            [hideToggle]="true"
            placeholder="mm/dd/yyyy"
            [formGroup]="sendDateForm"
            controlName="sendAtDate"
            [required]="true"
          >
          </lhpe-datepicker>
          <lhpe-select
            class="time-picker"
            [formGroup]="sendDateForm"
            controlName="sendAtTime"
            placeholder="time"
            [required]="true"
            [options]="timeOptions"
            [optionIsSelf]="true"
          >
          </lhpe-select>
          <lhpe-select
            class="am-pm-select"
            [formGroup]="sendDateForm"
            controlName="sendAtTimeFormat"
            placeholder="am/pm"
            [required]="true"
            [options]="hourFormatOptions"
            [optionIsSelf]="true"
          >
          </lhpe-select>
        </div>
      </div>
      <div class="inner-container">
        <div class="container-row">
          <div class="row-label">Remove at</div>
        </div>
        <div class="container-row date-row remove-date-row">
          <div class="icon">
            <button
              mat-button
              class="icon-btn"
              (click)="removeDatePicker.openPicker()"
              [disabled]="hasBeenSent"
            >
              <svg-icon
                src="assets/svg/calendar.svg"
                [svgStyle]="{
                  'width.px': '26.5',
                  'height.px': '26.5'
                }"
                svgClass="grey"
              >
              </svg-icon>
            </button>
          </div>
          <lhpe-datepicker
            class="date-picker"
            #removeDatePicker
            [hideToggle]="true"
            placeholder="mm/dd/yyyy"
            [formGroup]="removeDateForm"
            controlName="removeAtDate"
          >
          </lhpe-datepicker>
          <lhpe-select
            class="time-picker"
            [formGroup]="removeDateForm"
            controlName="removeAtTime"
            placeholder="time"
            [options]="timeOptions"
            [optionIsSelf]="true"
          >
          </lhpe-select>
          <lhpe-select
            class="am-pm-select"
            [formGroup]="removeDateForm"
            controlName="removeAtTimeFormat"
            placeholder="am/pm"
            [options]="hourFormatOptions"
            [optionIsSelf]="true"
          >
          </lhpe-select>
        </div>
      </div>
    </div>
    <div class="container tags-container">
      <div class="inner-container">
        <div class="area tags-area">
          <div class="container-row">
            <div class="row-label">Tags</div>
          </div>

          <div class="container-row">
            <div class="input-box icon-input-box">
              <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

              <mat-form-field>
                <input
                  matInput
                  (keyup)="applyTagFilter()"
                  matInput
                  type="text"
                  [(ngModel)]="tagSearchValue"
                  [disabled]="hasBeenSent"
                  placeholder="Search for tags in your library"
                />
              </mat-form-field>
            </div>
            <button
              *ngIf="!hasBeenSent"
              mat-button
              color="lightGreen"
              (click)="createTag()"
            >
              Create
            </button>
          </div>
          <div class="container-row">
            <lhpe-option-snack-group type="clickable">
              <lhpe-option-snack
                *ngFor="let tag of filteredTags"
                [option]="tag"
                [name]="tag"
                (optionClicked)="tagSelected(tag)"
                [disabled]="hasBeenSent"
              >
              </lhpe-option-snack>
            </lhpe-option-snack-group>
          </div>
          <ng-container *ngIf="selectedTags.length">
            <div class="container-row">
              <div class="row-label">Applied-tags:</div>
            </div>
            <div class="container-row">
              <lhpe-option-snack-group>
                <lhpe-option-snack
                  *ngFor="let tag of selectedTags"
                  [option]="tag"
                  [name]="tag"
                  (optionRemoved)="tagRemoved(tag)"
                  [disabled]="hasBeenSent"
                >
                </lhpe-option-snack>
              </lhpe-option-snack-group>
            </div>
          </ng-container>
        </div>

        <ng-container *ngIf="hasGeofencesList && hasBeaconRegionsList">
          <div class="area conversions-location-area">
            <div class="container-row">
              <div class="row-label">Conversion tracking</div>
            </div>
            <div class="container-row">
              <lhpe-select
                controlName="locations"
                placeholder="Select locations"
                [formGroup]="tagsFormGroup!"
                [options]="locations"
                [multiple]="true"
                optionValue="name"
              >
              </lhpe-select>
            </div>
            <div
              *ngIf="tagsFormGroup.controls.locations.value?.length"
              class="container-row"
            >
              <div class="row-label">Tracking enabled for:</div>
            </div>
            <div class="container-row">
              <lhpe-option-snack-group>
                <lhpe-option-snack
                  *ngFor="let location of selectedLocations"
                  [option]="location"
                  (optionRemoved)="locationRemoved(location)"
                  [disabled]="hasBeenSent"
                >
                </lhpe-option-snack>
              </lhpe-option-snack-group>
            </div>
          </div>
          <div class="area track-conversions-area">
            <div class="container-row">
              <lhpe-select
                controlName="conversions"
                placeholder="Track conversions for"
                [formGroup]="tagsFormGroup!"
                [options]="conversionTrackingOptions"
                optionValue="code"
                displayValue="name"
              >
              </lhpe-select>
            </div>
          </div>
        </ng-container>

        <div class="redemptions-feedback">
          <div class="redemptions-feedback-heading">
            Redemptions and feedback
          </div>
          <div class="options">
            <div class="redemption">
              Redemption code
              <mat-slide-toggle
                color="lightGreen"
                [formControl]="redemptionControl"
                [checked]="redemptionControl.value"
              >
                {{
                  tagsFormGroup!.controls.redemption.value
                    ? "Enabled"
                    : "Disabled"
                }}
              </mat-slide-toggle>
            </div>
            <div class="feedback">
              Thumbs up/down input
              <mat-slide-toggle
                color="lightGreen"
                [formControl]="feedbackControl"
                [checked]="feedbackControl.value"
              >
                {{
                  tagsFormGroup!.controls.feedback.value
                    ? "Enabled"
                    : "Disabled"
                }}
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
